(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["iframe-video"]) return;
  try {
    
	const postervideo = document.querySelector('[id^="Deferred-Poster-"]');
    postervideo.addEventListener('click', function(){
        if (!this.getAttribute('loaded')) {
          const content = document.createElement('div');
          content.appendChild(this.nextElementSibling.content.firstElementChild.cloneNode(true));
          this.parentElement.setAttribute('loaded', true);
          this.parentElement.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
        }
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
// Toggle Key Features Read More/Less
document.addEventListener('DOMContentLoaded', function() {
  const toggleButton = document.querySelector('.key-features-toggle');
  
  if (toggleButton) {
    console.log('Key features toggle button found!');
    
    toggleButton.addEventListener('click', function(event) {
      event.preventDefault();
      event.stopPropagation();
      
      console.log('Toggle clicked!');
      
      const content = this.previousElementSibling;
      const toggleText = this.querySelector('.toggle-text');
      
      console.log('Content element:', content);
      console.log('Toggle text:', toggleText);
      
      if (!content || !toggleText) {
        console.error('Key features elements not found');
        return;
      }
      
      const isExpanded = content.classList.contains('expanded');
      console.log('Currently expanded:', isExpanded);
      
      if (isExpanded) {
        // Collapse
        content.classList.remove('expanded');
        this.classList.remove('expanded');
        toggleText.textContent = 'Read More';
        console.log('Collapsed');
      } else {
        // Expand
        content.classList.add('expanded');
        this.classList.add('expanded');
        toggleText.textContent = 'Read Less';
        console.log('Expanded - max-height should be 2000px');
      }
      
      // Log the current classes
      console.log('Content classes:', content.className);
      console.log('Button classes:', this.className);
    });
  } else {
    console.error('Key features toggle button not found');
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-bar"]) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
      $('.btn-close').on('click', function(){
        $(this).parents('.parent-close').slideUp();
      })
  });

  } catch(e) { console.error(e); }
})();
})();
